import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex align-items-center position-relative settings-box-wrap for-card-radius",
  style: {"gap":"25px"}
}
const _hoisted_2 = {
  class: "d-flex align-items-center",
  style: {"gap":"5px","margin-top":"10px"}
}
const _hoisted_3 = {
  class: "d-flex align-items-center",
  style: {"gap":"5px","margin-top":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "cursor position-relative active-wrap2",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setRounded && _ctx.setRounded(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["settings-box", { 'rounded-style': _ctx.isRounded }])
      }, [...(_cache[3] || (_cache[3] = [
        _createStaticVNode("<span></span><span></span><span></span><span></span><span></span><span></span><span></span><span class=\"rounded-3\"></span><span class=\"rounded-3\"></span><span class=\"rounded-3\"></span><span class=\"rounded-3\"></span><span class=\"rounded-3\"></span><span class=\"rounded-3\"></span>", 13)
      ]))], 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-circle-fill position-relative top-1 fs-18 text-primary", { 'opacity-0': _ctx.isRounded, 'opacity-1': !_ctx.isRounded }])
        }, null, 2),
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-blank-circle-line position-relative fs-18 text-light-40 position-absolute start-0 bottom-0", { 'opacity-1': _ctx.isRounded, 'opacity-0': !_ctx.isRounded }])
        }, null, 2),
        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fw-semibold" }, "Radius", -1))
      ])
    ]),
    _createElementVNode("div", {
      class: "cursor position-relative active-wrap1",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setSquare && _ctx.setSquare(...args)))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["settings-box rounded-0", { 'square-style': !_ctx.isRounded }])
      }, [...(_cache[5] || (_cache[5] = [
        _createStaticVNode("<span class=\"rounded-0\"></span><span class=\"rounded-0\"></span><span class=\"rounded-0\"></span><span class=\"rounded-0\"></span><span class=\"rounded-0\"></span><span class=\"rounded-0\"></span><span class=\"rounded-0\"></span><span></span><span></span><span></span><span></span><span></span><span></span>", 13)
      ]))], 2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-circle-fill position-relative top-1 fs-18 text-primary", { 'opacity-0': !_ctx.isRounded, 'opacity-1': _ctx.isRounded }])
        }, null, 2),
        _createElementVNode("i", {
          class: _normalizeClass(["ri-checkbox-blank-circle-line position-relative fs-18 text-light-40 position-absolute start-0 bottom-0", { 'opacity-1': !_ctx.isRounded, 'opacity-0': _ctx.isRounded }])
        }, null, 2),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "fw-semibold" }, "Square", -1))
      ])
    ]),
    _createElementVNode("button", {
      class: "card-radius-square settings-btn",
      id: "card-radius-square",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleCardStyleRadius && _ctx.toggleCardStyleRadius(...args)))
    })
  ]))
}